var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.455 15.2212L18.205 12.3612V20.6112H1.375V3.73992H9.9L7.24625 6.48992H4.125V17.8337H15.4688L15.455 15.2212ZM20.625 4.72992C20.6233 5.52033 20.3066 6.27746 19.745 6.83367L12.2788 14.5474L6.77875 15.3449L7.7 10.0237L15.125 2.30992C15.5849 1.77119 16.2429 1.44106 16.9497 1.39446C17.6565 1.34786 18.3521 1.58873 18.8787 2.06242L19.8413 2.96992C20.3269 3.42849 20.6091 4.06217 20.625 4.72992ZM17.875 4.85367L17.2013 4.20742L10.3263 11.3299L10.2025 12.0862L11 11.9624L17.875 4.89492V4.85367Z",
    fill: "#0071D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2b31df24966a4d0bf1734230fbf10b84.svg";
export { ForwardRef as ReactComponent };